module.exports = __webpack_public_path__ + "static/media/sg8cr658.79540db2.png";